interface SmsConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
  className?: string;
}

/**
 * Optional SMS/text-message consent opt-in (A2P/10DLC).
 * Explicit, unchecked-by-default checkbox — never required to submit the form.
 * The label carries the carrier-required disclosures (sender, message types,
 * frequency, rates, STOP to opt out).
 */
function SmsConsentCheckbox({ checked, onChange, id = 'sms-consent', className }: SmsConsentCheckboxProps) {
  return (
    <label
      htmlFor={id}
      className={`mt-1 flex items-start gap-2 text-xs text-warm-500 cursor-pointer${className ? ` ${className}` : ''}`}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 flex-shrink-0 rounded border-warm-300 text-primary-600 focus:ring-primary-500"
      />
      <span>
        I agree to receive text messages from Stage Door Access regarding registrations, scheduling,
        event reminders, and customer support communications. Message frequency may vary. Message and
        data rates may apply. Reply STOP to opt out at any time.
      </span>
    </label>
  );
}

export default SmsConsentCheckbox;
